/** Path params for Opportunities API */
export const OPPORTUNITIES_API_PATHS = {
  opportunities: '/v1/opportunities',
  summaryModule: '/v1/opportunities/moduleSummary',
  response: '/user-response', // accept & reject response
  aopValues: '/v1/opportunities/aop-values',
  statusPills: '/v1/opportunities/status',
  lookupStatus: '/v1/opportunities/lookup-values',
  samplingStatus: '/v1/opportunities/sampling-status',
  samplingCount: '/v1/opportunities/sampling-count',
  export: '/v1/opportunities/export',
  autoCompelte: '/v1/opportunities/auto-complete',
  saveTracking: '/v1/opportunities/save-tracking',
  exportLookup: '/v1/opportunities/export-lookup',
  anomalyFilter: '/v1/opportunities/anomaly-filter',
  actionCount: '/v1/opportunities/pending-actions/count',
  gridCustomization: 'v1/opportunities/grid-customization-list',
  gridCustomizationUpdate: 'v1/opportunities/update-grid-customization-list',
  trainingOptions: '/v1/opportunities/training-options',
  acpOpportunities: '/v1/acp/acp-opportunities',
  acpUserResponse: '/v1/acp',
  acpGetModelCenter: '/v1/acp/get-model-center',
  labelModels:'/v1/acp/label-models'
};


export const PROFILES_API_PATHS = {
  feedback: 'v1/profiles/feedback',
  onBoarding: 'v1/profiles/on-board',
  kpis: 'v1/profiles/kpis',
  profiles: 'v1/profiles',
  activeUsers: 'v1/profiles/active-users',
  activeUser: 'v1/profiles/active-user',
  config: 'v1/config/user-config',
  roles: 'v1/profiles/roles',
  acpRoles: 'v1/acp/acp-roles',
  uimessages: 'v1/dashboard/ui-messages',
  updatePrivacyNotice: 'v1/profiles/updatePrivacyNotice'
};

export const DATAGPT_API_PATHS = {
  userInput: 'v1/dgpt/user-input-details',
  responseDetails:'v1/dgpt/query-response-details',
  getHistoryDetails: 'v1/dgpt/get-all-query',
  getDSModelResponse: 'v1/dgpt/get-response-dsmodel'
};
export const DASHBOARD_API_PATHS = {
  footer: 'v1/dashboard/footer',
  overview: 'v1/dashboard/review-immediately',
  dashboardfilter: 'v1/dashboard/filter-data',
  filterList: 'v1/dashboard/filter-list',
};

export const GAMETIME_API_PATH = {
  modelStageDetails: 'v1/acp/model-stage-details',
  // editModelList: 'v1/acp/get-model-list',
  getAllModels: 'v1/acp/get-all-models',
  modelTableauDetails: 'v1/acp/model-tableau-details',
  modelFeedback: 'v1/acp/model-feedback',
  updateModelQuestions: 'v1/acp/update-model-questions',
  stageQuestionDetails: 'v1/acp/stage-details',
  updateModelName: 'v1/acp/update-model-name',
  updateModelStage:'v1/acp/update-model-stage',
  saveTableauResponses: 'v1/acp/update-dashboard-responses',
  saveGandHTableauResponses: 'v1/acp/insert-tableau-data'

};
